import { getWindowObject } from './get-window-object';

export const getPerformanceObserverObject = ():
	| {
			new (callback: PerformanceObserverCallback): PerformanceObserver;
			prototype: PerformanceObserver;
			readonly supportedEntryTypes: ReadonlyArray<string>;
	  }
	| undefined => {
	const { PerformanceObserver } = getWindowObject() || {};

	return PerformanceObserver;
};
